/**
 * description 点击切换轮播
 * created by zhang.yingyu
 * modified on 2018-03-29
 */
"use strict";
angular.module("picCarouselModule", [])
    .directive("picCarousel", ["$timeout","$window", function($timeout,$window) {
        return {
            templateUrl: "./planningCenter/eventAnalysis/directive/picCarousel/picCarousel_tpl.html",
            scope:{
                picturesData:"="
            },
            restrict: "EA",
            replace: false,
            transclude: false,
            link:function(scope,element,attrs){
                $timeout(function(){

                    /**
                     * [initData description] 初始化数据
                     * @return {[type]} [description]
                     */
                    scope.$watch("picturesData", function (newVal, oldVal) {
                        if (typeof newVal == 'object') {
                            initStatus();
                            initData();
                        }
                    });
                    window.addEventListener("resize", function () {
                        initStatus();
                        initData();
                    });
                    function initStatus() {
                        scope.status = {
                            containWidth:$(".event_view_pic").width(),
                            childrenEle: element[0].children,
                            showBtnS:false
                        };
                        scope.data = {
                            mWidth: "307.7", //在获取不到图片的宽高时默认的宽度
                            mHeight: "180" //在获取不到图片的宽高时默认的高度
                        };
                    }
                    function initData() {
                        //如果没有图片数据或div未加载，则不继续执行
                        if (angular.isUndefined(scope.picturesData) || scope.picturesData.length === 0) {
                            return;
                        }
                        basicData();
                    }
                    function basicData(){
                        var container_width=$(".event_view_pic").width();
                        var  imgLen=scope.picturesData.length;
                        var  ceil_pic=Math.ceil(imgLen/3);
                        $timeout(function(){
                            $(".event_view_pic .event_view_pic_list").width(container_width*ceil_pic+'px');
                            $(".event_view_pic .event_view_pic_list li").width(((container_width-40)/3)+'px');
                            $(".event_view_pic .event_view_pic_list li img").width(((container_width-40)/3)+'px');
                        });
                        scope.index=0;
                        scope.totalLen=Math.ceil(scope.picturesData.length/3);
                        //图片移动
                        scope.isLeftDisabled=true;
                        if(imgLen/3==1){
                            scope.isRightDisabled=true;
                        }
                        //显示按钮
                        scope.showBtn=function(){
                            scope.status.showBtn=true;
                        };
                        scope.hideBtn=function(){
                            scope.status.showBtn=false;
                        };
                        //图片往左移
                        scope.viewToLeft=function(){
                            scope.index--;
                            if(scope.index==0){
                                scope.isLeftDisabled=true;
                            }else{
                                scope.isLeftDisabled=false;
                            }
                            scope.isRightDisabled=false;
                            $(".event_view_pic_list").animate({left: -container_width*scope.index+'px'}, {duration: 300, easing: "swing"});
                            return false;
                        };
                        //图片往右移
                        scope.viewToRight=function(){
                            if(imgLen>3){
                                scope.index++;
                                scope.isLeftDisabled=false;
                                if(scope.index==ceil_pic-1){
                                    scope.isRightDisabled=true;
                                }
                                $(".event_view_pic_list").animate({left: -container_width*scope.index+'px'}, {duration: 200, easing: "swing"});
                                return false;
                            }else{
                                scope.isRightDisabled=true;
                            }
                          };
                        }



                });

            }
        };
    }]);


